import * as styles from './styles';
import VerticalScrollArrow from '@components/VerticalScrollArrow';
import { useAgreementContext } from '@context/Agreement';

const Content = () => {
  const {
    scrollAgreement,
    scrollingRef,
    agreementTitle,
    displayAgreements,
    isDisplayWholeContent
  } = useAgreementContext();

  return (
    <div>
      <p css={styles.title}>{agreementTitle}</p>
      <div css={styles.content}>
        <div css={styles.agreementContentContainer}>
          <div ref={scrollingRef} css={styles.agreementContents}>
            {displayAgreements.map((agreement, index) => {
              return isDisplayWholeContent ? (
                <div css={styles.agreementContent} key={index}>
                  <p css={styles.subTitle}> {agreement.title}</p>
                  <p>{agreement.content}</p>
                </div>
              ) : (
                <p key={index}>{agreement.content}</p>
              );
            })}
          </div>
        </div>
        <div css={styles.scrollButtonContainer}>
          <VerticalScrollArrow isUp={true} onEnterPress={() => scrollAgreement('up')} />
          <VerticalScrollArrow
            isUp={false}
            onEnterPress={() => scrollAgreement('down')}
          />
        </div>
      </div>
    </div>
  );
};

export default Content;
